import React, { useRef, useCallback, useMemo } from "react"

import useTracking from "hooks/useTracking"

import {
  List,
  Title,
  Items,
  ItemWrapper,
  Category,
  PromoIcon,
  TitleLink,
  ReviewLink,
  ArrowIcon,
} from "./styles"

const QuickView = ({ element }) => {
  const { anchor, title, items } = element

  return (
    <List id={`mbg-${anchor}`} className="experiment-product-review-quick-list-A">
      <Title>{title}</Title>
      <Items>
        {items.map((item, idx) => (
          <Item key={`quick-list-item-${item.id}`} idx={idx} {...item} />
        ))}
      </Items>
    </List>
  )
}

const Item = ({ idx, title, category, sources = [], productId }) => {
  const source = sources.length && sources[0]
  const sourceName = source ? source.source : ""

  const { trackClick } = useTracking()
  const clickRef = useRef(null)

  const trackingId = `Review Component | ${title} | ${sourceName}`
  const trackingProps = {
    label: trackingId,
    category: "Commerce Engagement",
    product: title,
    product_id: productId,
    quickView: true,
    source: sourceName,
  }

  trackClick(clickRef, trackingId, trackingProps)

  const isPromotionValid = useCallback((promotion) => {
    const actualDate = new Date().toISOString()
    return (
      promotion?.active &&
      (promotion?.startsAt || promotion?.endsAt
        ? promotion?.startsAt < actualDate || promotion?.endsAt > actualDate
        : true)
    )
  }, [])

  const sourceWithPromotion = useMemo(
    () =>
      sources.find(
        ({ promotion }) =>
          isPromotionValid(promotion) && new RegExp(promotion?.code, "i").test(promotion?.url),
      ) || sources.find(({ promotion }) => isPromotionValid(promotion)),
    [sources, isPromotionValid],
  )

  const url = useMemo(() => {
    if (sourceWithPromotion) {
      const { promotion } = sourceWithPromotion
      if (new RegExp(promotion.code, "i").test(promotion.url)) {
        return { address: promotion.url, target: "_blank" }
      }
      return { address: `#review-item-${idx}`, target: "_self" }
    }

    return { address: sources[0]?.url ? sources[0].url : null, target: "_blank" }
  }, [sourceWithPromotion, sources, idx])

  return (
    <ItemWrapper>
      {category && (
        <Category>
          {category}
          {sourceWithPromotion && <PromoIcon width={30} height={19} id="promo-icon" />}
        </Category>
      )}
      <TitleLink href={url.address} target={url.target} rel="sponsored" ref={clickRef}>
        {title}
      </TitleLink>
      {url.address && (
        <ReviewLink href={`#review-item-${idx}`}>
          Go to review
          <ArrowIcon id="greater-than-icon" width="9" height="16" />
        </ReviewLink>
      )}
    </ItemWrapper>
  )
}

export default QuickView
